<template>
  <div v-if="!disableAddonModal">
    <head>
      <!-- Add this line -->
      <link rel="stylesheet" :href="css">
    </head>
    <div class="black-overlay"></div>
    <div class="modal modal--postfreegame" id="welcome_modal">
      <div class="modal__content">
           <div class="game_bg pre_post">
        <div class="game_box">
          <div class="subtitle" v-if="!isLantern">{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_you_earned }}</div>
          <div class="title" v-if="!isLantern">{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_destroy }}</div>
          <div class="title" v-if="isLantern">{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_lets_celebrate }}</div>
          <div class="subtitle" v-if="isLantern">{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_you_earned }}<br>  {{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_a_special }}</div>
          <img :src="image" alt="game background">
          <p>{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_you_have }} {{timerForLanternGame}} {{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_seconds  }}</p>
          <p>{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_the_more }}</p>
          <button type="button" class="btn" @click="goToAddOnGame">{{ getTranslations.home_game_addongamelanterns_modals_pre_game_lanterns_play_now }}</button>
        </div>
      </div>
      </div>
    </div>
    <div class="modal-overlay" @click="close()"></div>

  </div>
</template>


<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'pre-game-lanterns',
  data() {
    return {
      disableAddonModal: false,
      css: '',
      image: '',
      isLantern: false,
    };
  },
  created() {
    this.setActiveAddOnMiniGame(true);
    if (this.fallingItemsAddOnGameCss === 'lanterns') {
      this.isLantern = true;
      this.image = '/static/mini_games/Falling_Lanterns_Game/assets/bg_lanterns.png';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns.css';
    } else {
      this.image = '/static/mini_games/Falling_Lanterns_Game/assets/bg_meteorites.png';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites.css';
    }
    this.showHideModal();
  },
  mounted() {
  },
  methods: {
    ...mapMutations('profile', [
      'clearLanternGame',
    ]),
    ...mapMutations('common', [
      'setActiveAddOnMiniGame',
    ]),
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('user has not leveled up, going to home page');
          /* eslint-disable */
          this.currentModal = null;
        });
      });
    },
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    close() {
      this.clearLanternGame();
      this.setActiveAddOnMiniGame(false);
    },
    goToAddOnGame() {
      this.disableAddonModal = true;
      this.$router.push({name: 'addOnGameLantern', params: { fromPreGame: 'true' } });
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'activeAddOnMiniGame',
      'timerForLanternGame',
      'fallingItemsAddOnGameCss',
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapState('game', [
      'homePlayerTotalEarnedPoints',
      'gameID',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>
<!--<style >-->
<!--  /* Import lanterns.css */-->
<!--  @import url('../../../../../../static/mini_games/Falling_Lanterns_Game/lanterns_AR.css');-->
<!--</style>-->




// WEBPACK FOOTER //
// src/components/home/game/addongamelanterns/modals/PreGameLanterns.vue